import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Auto-rotating hero for the property pages. The full gallery grid below stays untouched.
export const HeroSlider = ({ images, alt }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const count = images.length;

  useEffect(() => {
    if (paused || count < 2) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % count), 5000);
    return () => clearInterval(t);
  }, [paused, count]);

  const go = (step) => setIndex((i) => (i + step + count) % count);

  return (
    <div
      className="relative h-[52vh] md:h-[70vh] overflow-hidden bg-[#0F2A52]"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid="property-hero-slider"
    >
      {images.map((src, i) => (
        <img
          key={src + i}
          src={src}
          alt={`${alt} — photo ${i + 1} of ${count}`}
          loading={i === 0 ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
          style={{ opacity: i === index ? 1 : 0 }}
          data-testid={`hero-slide-${i}`}
        />
      ))}
      <div className="absolute inset-0 bg-black/35" />

      {count > 1 && (
        <>
          <button
            onClick={() => go(-1)}
            aria-label="Previous photo"
            data-testid="hero-prev"
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 p-2.5 rounded-full bg-black/25 text-[#FCFAF6] backdrop-blur-sm hover:bg-black/45 transition-colors"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => go(1)}
            aria-label="Next photo"
            data-testid="hero-next"
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 p-2.5 rounded-full bg-black/25 text-[#FCFAF6] backdrop-blur-sm hover:bg-black/45 transition-colors"
          >
            <ChevronRight size={20} />
          </button>
          <div className="absolute top-5 md:top-7 right-5 md:right-8 z-20 flex gap-2" data-testid="hero-dots">
            {images.map((src, i) => (
              <button
                key={`dot-${src}${i}`}
                onClick={() => setIndex(i)}
                aria-label={`Show photo ${i + 1}`}
                data-testid={`hero-dot-${i}`}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  i === index ? "w-7 bg-[#B08A3E]" : "w-1.5 bg-[#FCFAF6]/60 hover:bg-[#FCFAF6]"
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HeroSlider;
